import ReceiptFromProduction from '@/models/ReceiptFromProduction/ReceiptFromProduction';

export default class ReceiptFromProductionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderProcessDetailId  = '';
		this.workOrderProcessDetailObject  = {};
		this.workOrderProcessDetailPart = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			workOrderProcessDetailId : '0',
			workOrderProcessDetailPart : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}